import { useEffect, useState, useMemo } from "react";
import productos from "../../hooks/productos.json";
import DocumentMeta from "react-document-meta";

const Descargas = () => {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [date, setDate] = useState({ day: "", month: "", year: "" });

  const list = useMemo(() => {
    const tempList = {};
    productos.map((producto) => {
      if (producto.documents) {
        producto.documents.map((document) => {
          tempList[document.type] ??= [];
          document.product = producto.title;
          tempList[document.type].push(document);
          return document; // Necesario para el uso de map
        });
      }
      return producto; // Necesario para el uso de map
    });
    return tempList;
  }, [productos]);

  useEffect(() => {
    let results = Object.values(list).flat();

    if (search) {
      const searchLower = search.toLowerCase();
      results = results.filter(
        (document) =>
          document.title.toLowerCase().includes(searchLower) ||
          document.product.toLowerCase().includes(searchLower) ||
          document.type.toLowerCase().includes(searchLower) ||
          document.date.toLowerCase().includes(searchLower)
      );
    }

    if (category) {
      results = results.filter((document) => document.type === category);
    }

    if (selectedProduct) {
      results = results.filter(
        (document) => document.product === selectedProduct
      );
    }

    if (date.day || date.month || date.year) {
      results = results.filter((document) => {
        const [docDay, docMonth, docYear] = document.date.split("-");
        return (
          (!date.day || docDay === date.day) &&
          (!date.month || docMonth === date.month) &&
          (!date.year || docYear === date.year)
        );
      });
    }

    setProducts(results);
  }, [search, category, selectedProduct, date, list]);

  const searcher = (e) => {
    setSearch(e.target.value);
  };

  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
  };

  const handleProductChange = (e) => {
    setSelectedProduct(e.target.value);
  };

  // Agrupar productos por categoría utilizando map
  const groupedProducts = useMemo(() => {
    const grouped = {};
    products.map((document) => {
      grouped[document.type] ??= [];
      grouped[document.type].push(document);
      return document;
    });
    return grouped;
  }, [products]);

  const getNameByKey = (key) => {
    switch (key) {
      case "Manual":
        return "Manuales";
      case "Folleto":
        return "Folletos";
      default:
        return key;
    }
  };

  return (
    <DocumentMeta
      title="Descargas"
      description="Descargas"
      canonical="https://www.agrodrone.cl/descargas"
      meta={{
        charset: "utf-8",
        name: {
          keywords: `descargas, manuales, folletos, videos instructivos`,
        },
      }}
    >
      <div className="page-title-area ptb-100">
        <div className="container">
          <div className="page-title-content">
            <h1>Descargas</h1>
          </div>
        </div>
      </div>
      <div className="career-single-area pb-50">
        <section id="career" className="career-section">
          <div className="container">
            <div className="flex-container">
              <aside className="sidebar d-none d-md-block">
                <h3 className="bold">Filtros</h3>
                <input
                  value={search}
                  onChange={searcher}
                  type="text"
                  className="form-control mt-3 shadow-sm"
                  placeholder="Buscar"
                />
                <h6 className="pt-20 bold">Categoría</h6>
                <select
                  onChange={handleCategoryChange}
                  className="form-control mt-3 shadow-sm"
                >
                  <option value="">Todas</option>
                  <option value="Manual">Manuales</option>
                  <option value="Folleto">Folletos</option>
                </select>
                <h6 className="pt-20 bold">Productos</h6>
                <select
                  onChange={handleProductChange}
                  className="form-control mt-3 shadow-sm pt-custom"
                >
                  <option value="">Todos</option>
                  {productos.map((producto) => (
                    <option key={producto.title} value={producto.title}>
                      {producto.title}
                    </option>
                  ))}
                </select>
              </aside>
              <div className="content p-0 p-md-3 pt-3">
                {Object.keys(groupedProducts).map((key) => {
                  const categoryProducts = groupedProducts[key];
                  if (categoryProducts.length === 0) return null; // No renderizar si no hay productos en la categoría
                  return (
                    <div key={key}>
                      <h3>{getNameByKey(key)}</h3>
                      <table className="table table-striped table-hover mt-3 shadow-lg">
                        <thead>
                          <tr>
                            <th>Nombre</th>
                            <th className="d-none d-md-block">Producto</th>
                            <th className="d-none d-md-block">Fecha</th>
                            <th>Descargar</th>
                          </tr>
                        </thead>
                        <tbody>
                          {categoryProducts.map((document) => (
                            <tr key={document.id}>
                              <td>{document.title}</td>
                              <td className="d-none d-md-block">{document.product}</td>
                              <td className="d-none d-md-block">{document.date}</td>
                              <td>
                                {document.download ? (
                                  <a
                                    href={
                                      process.env.PUBLIC_URL +
                                      "/assets/docs/" +
                                      document.type.toLowerCase() +
                                      "/" +
                                      document.href
                                    }
                                    target="_blank"
                                    className="btn btn-primary"
                                    rel="noreferrer"
                                  >
                                    Descargar
                                  </a>
                                ) : (
                                  <a
                                    href={document.href}
                                    target="_blank"
                                    className="btn btn-success"
                                    rel="noreferrer"
                                  >
                                    Abrir
                                  </a>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </section>
      </div>
    </DocumentMeta>
  );
};

export default Descargas;
